import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { ImageComponent, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { CookieNgrxModule, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SafePipe, TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { ButtonModule } from '@teamfoster/sdk/button';

import { NgClass } from '@angular/common';

import { IconComponent } from '@teamfoster/sdk/icon';
import { CtaItem } from '../../models';

@Component({
  selector: 'app-cta-card',
  templateUrl: './cta-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './cta-card.component.scss',
  imports: [
    CookieNgrxModule,
    TextUtilityModule,
    ButtonModule,
    ImageComponent,
    NgClass,
    IconComponent,
    ResizeHtmlImagesPipe,
    SafePipe,
    StripEmbedPipe,
  ],
})
export class CtaCardComponent {
  card = input.required<CtaItem>();
  size = input<undefined | 'small'>();
  hideImage = input<boolean>();
}
